import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { PaletteColor } from '@mui/material';

export const root: SxStyle = {
  px: 2,
  py: 1,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
};

export const box: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[400],
  height: '80%',
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const text1: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const text2: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const status: SxStyleFunc<PaletteColor> = (color) => ({
  color: color[700],
  background: color[100],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  width: (p) => p.spacing(8.5),
  height: (p) => p.spacing(2.5),
  borderRadius: (p) => p.spacing(0.5),
});

export const action: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  textDecoration: 'underline',
  cursor: 'pointer',
};
